import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  CardActions,
  ListButton,
  BooleanInput,
  SelectInput,
  RefreshButton,
} from "react-admin";

const UserTitle = ({ record }) => {
  return (
    <span>
      Company {record.name} - {record.email}
    </span>
  );
};

const PostEditActions = ({ basePath }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    <RefreshButton />
  </CardActions>
);

export default (props) => (
  <Edit actions={<PostEditActions />} title={<UserTitle />} {...props}>
    <SimpleForm>
      <TextInput name="Company name" source="name" />
      <SelectInput
        label="Company role"
        source="companyRole"
        choices={[
          { id: "CARRIER", name: "Carrier" },
          { id: "SUPPLIER", name: "Supplier" },
        ]}
      />
      <BooleanInput label="Active?" source="active" />
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/companies/Edit.js